module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@babel/runtime/regenerator/index.js
// module id = 16
// module chunks = 69